import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-risk-score-trend",
  templateUrl: "./risk-score-trend.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskScoreTrendComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.RISK_SCORE_TREND_DW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID];
}
